export const hostname = 'https://casbin-backend.herokuapp.com'